import { Box } from '@primer/react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useCommonContext } from '../../contexts/common';
import { ILopSelectedItemRequest } from '../../models/request/danh-muc/ILopSelectedItemRequest';
import LopListContainer from '../lop-hanh-chinh/lop-list-container';
import HocSinhListContainer from './hocsinh-faceid-list-container';

export interface ILopSelected {
	dm_lop: ILopSelectedItemRequest;
	ten_lop: string;
}

const FaceId = () => {
	const [tabSelected, setTabSelected] = useState<'hoc_sinh' | 'phu_huynh'>('hoc_sinh');

	const [lopSelected, setLopSelected] = useState<ILopSelected>({
		dm_lop: {} as ILopSelectedItemRequest,
		ten_lop: '',
	});
	return (
		<Box
			sx={{
				height: "calc(100vh - 100px)",
				display: "flex", 
			}}
		>
			<Box
				sx={{
					pt: 3, 
					width: "260px", 
					flexShrink: 0,  
				}}
			>
				<LopListContainer
					lopSelected={lopSelected}
					setLopSelected={(lopSelected) => setLopSelected(lopSelected)}
				/>
			</Box>
			<Box
				sx={{
					flex: 1,
					overflow: "auto", 
				}}
			>
				<HocSinhListContainer
					lopSelected={lopSelected}
					onViewChanged={(key) => {
						setTabSelected(key);
					}}
				/>
			</Box>
		</Box>
	);


};

export default FaceId;
